/**
 * Cliente de trabajo actual para llamadas API cuando el usuario tiene varios Client.
 * Debe coincidir con la clave que escribe `CompanyProvider` al persistir el contexto (`lastClientId`).
 */
export const LAST_ACTIVE_CLIENT_ID_STORAGE_KEY = 'lastClientId';

/**
 * Resuelve el clientId a enviar en `GET accessClient` (y similares) cuando el caller no lo pasa explícito.
 * Orden: parámetro explícito → `lastClientId` (último cliente cargado en sesión) → `selectedClientId` (cambio de cliente en curso).
 */
export function getActiveClientIdForApi(explicitClientId?: string | null): string | undefined {
  const trimmed = explicitClientId?.trim();
  if (trimmed) return trimmed;
  try {
    if (typeof window === 'undefined' || !window.localStorage) return undefined;
    const last = window.localStorage.getItem(LAST_ACTIVE_CLIENT_ID_STORAGE_KEY)?.trim();
    if (last) return last;
    const selected = window.localStorage.getItem('selectedClientId')?.trim();
    if (selected) return selected;
  } catch {
    /* private mode / disabled storage */
  }
  return undefined;
}
